import React from 'react';
import Catalog from '~/Catalog';
import Button from '~/components/atom/Button';
import { useUpdateLfaAccountSettingsMutation } from '~/graphql/types';
import useAddToast from '~/hooks/useAddToast';
import useCurrentAccount from '~/hooks/useCurrentAccount';
import formatToastMessage from '~/util/formatToastMessage';

const text = {
  activate: 'Activeren',
  updateError: Catalog.genericUnknownErrorMessageShort,
  updateSuccess: Catalog.genericSuccessMessage,
  fillInPhoneNumber: 'Vul een telefoonnummer in om LeadAssist te activeren',
};

const ActivateButton: React.FC<{
  refetch: () => Promise<any>;
  callbackPhoneNumber: string | null;
}> = ({ refetch, callbackPhoneNumber }) => {
  const { id: accountId } = useCurrentAccount();
  const addToast = useAddToast();
  const [updateLfaAccountSettings, { loading: activateLoading }] =
    useUpdateLfaAccountSettingsMutation();

  return (
    <Button
      appearance="secondary"
      label={text.activate}
      onClick={() => {
        if (!callbackPhoneNumber) {
          return addToast([
            formatToastMessage(text.fillInPhoneNumber, 'danger'),
          ]);
        }

        void updateLfaAccountSettings({
          variables: {
            accountId,
            update: { Activate: true },
          },
        }).then(({ data, errors }) => {
          if (errors && errors.length > 0) {
            return addToast([formatToastMessage(text.updateError, 'danger')]);
          }

          if (data) {
            addToast([formatToastMessage(text.updateSuccess, 'success')]);
            void refetch();
          }
        });
      }}
      size="medium"
      loading={activateLoading}
    />
  );
};

export default ActivateButton;
